export default __webpack_public_path__ + "static/media/CMA.90838e27.jpg";